import 'twin.macro';

import React from 'react';
import { useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';

import { getApplicationUuid } from '@/app/store/slices/app';
import { getAccessToken } from '@/app/store/slices/auth';
import Footer from '@/views/footer';

import { Stepper } from '../stepper';
import WebSocketComponent from '../websocket';

const StepLayout = ({ withoutStepper = false, footer = false }) => {
  const application_uuid = useSelector(getApplicationUuid);
  const token = useSelector(getAccessToken);
  return (
    <>
      <WebSocketComponent application_uuid={application_uuid} access_token={token} />
      <div tw='mt-[3px] sm:mt-[40px] max-w-content mx-auto pb-[48px]'>
        {!withoutStepper && <Stepper />}
        <Outlet />
      </div>
      {footer && <Footer />}
    </>
  );
};

export default StepLayout;
